module.exports = __webpack_public_path__ + "img/equifinance.0f1f632e.jpg";